<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :ariaLabel="$t('companies.exclude_organismos')">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('companies.exclude_organismos')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div ref="selectRefAgencies">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.organismos_cif')}}
                <el-form-item prop="agency">
                  <AccessibleElSelect
                    v-model="form.agency"
                    prop="agency"
                    :options="agenciesForAccessibleSelect"
                    :isMultiple="true"
                    :isDisabled="isLoadingSelect"
                  >
                    <template slot="label">{{$t('app.organismos_cif')}}</template>
                  </AccessibleElSelect>
                </el-form-item>
              </label>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
        <base-button mode="secondary-phantom-blue"
          class="w-full"
          v-if="!isAllSelected" 
          :disabled="!isLoadedData || isLoadingSelect || isEmptyList" 
          :text="$t('app.select_all')" 
          @click="handleSelectAll" 
          :loading="isLoadingSelect"
          />
        <base-button v-else :text="$t('app.unselect_all')" mode="secondary-phantom-blue"
          class="w-full"
          @click="handleUnSelectAll"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect || isEmptyList"
          />
          <div class="w-48 "></div>
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
          class="w-full"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
        <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply" 
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './base/BaseDialogButton.vue'
import AccessibleElSelect from './elementui/AccessibleElSelect.vue'
import { getOrganismosByClienteBySede } from '@/services/companies/getOrganismosByClienteBySede'
// import { getSedes } from '@/services/app/getSedes'

export default
{
  name: 'company-locations-link-agency-exclusion-dialog',
  components: {
    BaseDialogButton,
    AccessibleElSelect
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    companyId: {
      type: [Number, String],
      default: -1
    },
    pgnId: {
      type: [Number, String],
      default: -1
    },
    agenciesBase: {
      default: null
    }
  },
  watch: {
    isOpen (value, oldValue) {
      this.agenciesBaseControl(this.agenciesBase)
    },
    agenciesBase: function (value, oldValue) {
      this.agenciesBaseControl(value)
    },
    pgnId: function (value, oldValue) {
      this.updateAgenciesBase(value)
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        agency: []
      },
      agencies: [],
      isLoadedData: false,
      loadingActionSelect: false,
      loadingActionUnSelect: false
    }
  },
  mounted: async function () {
  },
  computed: {
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    isEmptyList: function () {
      return this.agencies === undefined || this.agencies === null || this.agencies.length === 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    isAllSelected: function () {
      if (this.agencies.length === this.form.agency.length) return true
      else return false
    },
    agenciesForAccessibleSelect: function () {
      return this.agencies.map(agency => ({ id: agency.value, name: agency.label }))
    },
  },
  methods: {
    updateAgenciesBase: async function (value) { 
      this.agencies = []
      if (value !== null && value !== undefined) {
        this.isLoadedData = false
        const params = {
          idCIFEmpresa: this.companyId,
          idPGN: value,
        }
        const data = await getOrganismosByClienteBySede(params)
        if (data.blnError === true) {
          this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
        } else {
          data.DatosOrganismos.forEach(row => {
            this.agencies.push({ value: row.idOrganismo, label: this.formatNombre(row) })
          })
        }
        this.isLoadedData = true
      }
    },
    formatNombre (element) {
      return this.truncate(element.Nombre, 50, false) + ' - ' + this.truncate(element.CIF, 50, false)
    },
    agenciesBaseControl (value) {
      if (value !== null) {
        this.form.agency = value.map(x => x.idOrganismo)
      }
    },
    onExpand (value) {
      // console.log('expand OPEN')
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      // console.log('onChangeInput', 'onChangeInput')
      setTimeout(() => {
        this.heightInput = this.$refs.selectRefAgencies.clientHeight
      }, 100)
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.form.agency = []
    },
    apply: function () {
      this.isOpen = !this.isOpen
      this.$emit('applyDialog', this.form.agency)
      this.form.agency = []
    },
    handleSelectAll: async function () {
      await this.handleUnSelectAll()
      this.loadingActionSelect = true
      this.agencies.forEach(element => {
        setTimeout(() => {
          this.form.agency.push(element.value)
          if (this.form.agency.length === this.agencies.length) {
            this.loadingActionSelect = false
            this.loadingActionUnSelect = false
          }
        }, 100)
      })
    },
    handleUnSelectAll: async function () {
      this.loadingActionUnSelect = true
      const staticLength = this.form.agency.length
      for (let index = 0; index < staticLength; index++) {
        setTimeout(() => {
          this.form.agency.pop()
          if (this.form.agency.length === 0) this.loadingActionUnSelect = false
        }, 100)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
